import { EditorState, ContentState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import React, { useState, useEffect, useRef } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { useSelector } from 'react-redux';
import { EditorToolbarOptions } from '@debbie/common/dist/constants.js';
import { Button } from './index.js';
import { styled } from 'styled-components';
import { encodeText, PARSE_RESULT_TYPE, parseText } from '../utils/templates.js';
const WYSIWYGEditor = (props) => {
    const editorRef = useRef(null);
    const lang = useSelector((s) => s.lang);
    const [editorState, setEditorState] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft.default(encodeText(props.html || '', props.mentionSuggestions || [])).contentBlocks)));
    useEffect(() => {
        if (props.autoFocus && editorRef && editorRef.current) {
            // @ts-ignore
            editorRef.current?.focusEditor();
        }
    }, [editorRef]);
    useEffect(() => {
        if (props.html) {
            setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft.default(encodeText(props.html || '', props.mentionSuggestions || [])).contentBlocks)));
        }
    }, [props.html]);
    return (React.createElement(WYSIWYGEditorWrapper, { hideToolbar: props.hideToolbar },
        React.createElement(Editor, { ref: editorRef, toolbar: { options: EditorToolbarOptions }, editorState: editorState, onEditorStateChange: (newEditorState) => {
                setEditorState(newEditorState);
            }, stripPastedStyles: true, mention: props.mentionSuggestions
                ? {
                    separator: ' ',
                    trigger: '@',
                    suggestions: props.mentionSuggestions.map((suggestion) => ({
                        value: suggestion.label,
                        text: suggestion.label,
                        url: suggestion.label,
                    })),
                }
                : undefined }),
        React.createElement("br", null),
        React.createElement(Button, { block: true, onClick: () => {
                props.onChange(parseText(draftToHtml(convertToRaw(editorState.getCurrentContent())), props.mentionSuggestions || [], PARSE_RESULT_TYPE.HTML));
            } }, lang.inputs.save)));
};
export default WYSIWYGEditor;
const WYSIWYGEditorWrapper = styled.div `
  ${(props) => props.hideToolbar
    ? `
      .rdw-editor-toolbar {
        display: none;
        position: sticky;
        top: 0px;
        z-index: 999;
      }
      .rdw-editor-wrapper {
        .rdw-editor-main {
          min-height: 45px;
          border-top: 1px solid #ccc;
          border-top-left-radius: 3px;
          border-top-right-radius: 3px;

          .public-DraftStyleDefault-block {
            margin: 0;
          }
        }
      }
    `
    : ''}
`;
//# sourceMappingURL=WYSIWYGEditor.js.map